/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurvePoolLike,
  ICurvePoolLikeInterface,
} from "../ICurvePoolLike";

const _abi = [
  {
    inputs: [],
    name: "get_virtual_price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurvePoolLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurvePoolLikeInterface {
    return new utils.Interface(_abi) as ICurvePoolLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurvePoolLike {
    return new Contract(address, _abi, signerOrProvider) as ICurvePoolLike;
  }
}
